let csrf;
let accountRequest;

export function api(path, body) {
  if (path === '/account' && body === undefined) {
    if (!accountRequest) accountRequest = request(path).finally(() => { accountRequest = null; });
    return accountRequest;
  }
  return request(path, body);
}

async function request(path, body) {
  if (body !== undefined && !csrf) await api('/account');
  const response = await fetch(`/api${path}`, {
    method: body === undefined ? 'GET' : 'POST',
    credentials: 'same-origin',
    cache: 'no-store',
    headers: body === undefined ? {} : { 'Content-Type': 'application/json', 'X-CSRF-Token': csrf },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const data = await response.json();
  if (data.csrf) csrf = data.csrf;
  if (!response.ok) {
    if (response.status === 403) csrf = undefined;
    const error = new Error(data.error || 'Unable to reach Voidhead. Please try again.');
    error.status = response.status;
    throw error;
  }
  return data;
}
